import { useQuery } from '@th/react-query';
import AxiosClient from '../../utils/AxiosClient';
import logAxiosError from '../../utils/logAxiosError';
import { FullListing } from '@th/shared/src/types/FullListing';
import { AxiosError } from 'axios';
import { WatchedSearch } from '@th/shared/src/types/WatchedSearch';

export default function useFetchWatchedNeighborhood(
  userId: string,
  listing: FullListing,
): {
  watchedNeighborhood: WatchedSearch;
  isWatchedNeighborhoodActive: boolean;
  isEnabledAndLoading: boolean;
  isEnabledAndFetching: boolean;
  isLoading: boolean;
  isSuccess: boolean;
} {
  const endpoint = `/api/v1/watched/neighborhoods/get`;
  const isEnabled = Boolean(userId);

  const { data, isLoading, isFetching, isSuccess } = useQuery(
    ['fetchWatchedNeighborhood', listing.id],
    async () => {
      return AxiosClient.post(endpoint, {
        userId,
        searchFilters: {
          propertyTypes: listing.propertyTypesFilterOptions(),
          neighborhoodName: listing.address.neighborhood,
          transactionType: listing.transactionType,
        },
      });
    },
    {
      enabled: isEnabled,
      refetchOnWindowFocus: true,
      onError: (err: AxiosError) => {
        logAxiosError(`useFetchWatchedNeighborhood GET ${endpoint}`, err);
      },
    },
  );

  const watchedNeighborhood = data?.data?.watchedNeighborhood;

  return {
    watchedNeighborhood,
    isWatchedNeighborhoodActive: Boolean(watchedNeighborhood),
    isEnabledAndLoading: isEnabled && isLoading,
    isEnabledAndFetching: isEnabled && isFetching,
    isLoading,
    isSuccess,
  };
}
